import { SocialChannels } from "@contracts/socialNetworks";

export interface SocialChannelData {
  channelType: SocialChannels;
  channelId: string; // e.g., Facebook Page ID or Instagram Business Account ID
  displayName?: string | null;
  status?: string | null;
}

export interface DaySlot {
  // .NET DayOfWeek: Sunday = 0, Monday = 1, ... Saturday = 6
  day: number;
  // Represented as HH:mm:ss string from server; we commonly edit HH:mm
  time: string;
}

export interface PostingSchedule {
  timeZone: string; // IANA, e.g. "America/Chicago"
  // The posting schedule as a simple list of day/time slots
  schedule?: DaySlot[];
}

export interface CustomerSocialMediaSettingsData {
  id: string;
  customerId: string;
  calendarId: string;
  bundleSocialTeamId: string | null;

  socialChannels: SocialChannelData[];
  postingSchedule: PostingSchedule;

  postsPerWeek: number;
  mediaPerPost: number; // images/videos per post
  weeksToGenPosts: number; // weeks to generate posts at a time

  interests?: string;
  interestsDebug?: string;

  // Section visibility toggles
  enableInterests?: boolean;
  enableLocalEvents?: boolean;
  enableThemes?: boolean;

  // Audit (not required for PUT from client, but may be present on GET)
  createdDate?: string;
  createdBy?: string;
  updatedDate?: string;
  updatedBy?: string;
}

export interface TimeZoneOption {
  name: string;
  zoneId: string;
}

export const COMMON_US_TIMEZONES: TimeZoneOption[] = [
  { name: "Eastern Time", zoneId: "America/New_York" },
  { name: "Central Time", zoneId: "America/Chicago" },
  { name: "Mountain Time (with DST)", zoneId: "America/Denver" },
  { name: "Mountain Time (no DST)", zoneId: "America/Phoenix" },
  { name: "Pacific Time", zoneId: "America/Los_Angeles" },
];
